import { useEffect } from "react";
import voiceIcon from "../../Assets/icon/explore/sheet-voice.svg";
import keyboardIcon from "../../Assets/icon/explore/sheet-keyboard.svg";
import { MODALITY_COPY } from "./copy";

/**
 * The Voice / Text chooser a Dialogue opens with (Figma 10792:21207).
 *
 * Modality is picked after Start or Continue is tapped, never before (guide
 * §7.1), so the Detail and the Active Dialogues rail both raise this sheet.
 * It is a bottom sheet on a phone and a centred card on a wider screen.
 *
 * `onChoose("voice" | "text")` hands the choice back; the caller owns routing.
 * `labels` ({voice, voiceHint, text, textHint}) overrides the option copy —
 * the Daily Check-In reuses this sheet with its server-served strings.
 * `busy` disables both options while the caller is starting the session.
 */
function ModalitySheet({ open, title, subtitle, labels, busy, onChoose, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  const copy = { ...MODALITY_COPY, ...(labels || {}) };

  return (
    <div className="ex-sheet" role="presentation" onClick={onClose}>
      <div
        className="ex-sheet__panel"
        role="dialog"
        aria-modal="true"
        aria-label={title || MODALITY_COPY.startTitle}
        onClick={(e) => e.stopPropagation()}
      >
        <span className="ex-sheet__grabber" aria-hidden="true" />
        <div className="ex-sheet__text">
          <h2 className="ex-sheet__title">{title || MODALITY_COPY.startTitle}</h2>
          <p className="ex-sheet__subtitle">{subtitle || MODALITY_COPY.subtitle}</p>
        </div>
        <div className="ex-sheet__options">
          <button
            type="button"
            className="ex-sheet__option"
            disabled={busy}
            onClick={() => onChoose?.("voice")}
          >
            <span className="ex-sheet__circle">
              <img src={voiceIcon} alt="" width="32" height="32" />
            </span>
            <span className="ex-sheet__label">{copy.voice}</span>
            <span className="ex-sheet__hint">{copy.voiceHint}</span>
          </button>
          <button
            type="button"
            className="ex-sheet__option"
            disabled={busy}
            onClick={() => onChoose?.("text")}
          >
            <span className="ex-sheet__circle">
              <img src={keyboardIcon} alt="" width="32" height="32" />
            </span>
            <span className="ex-sheet__label">{copy.text}</span>
            <span className="ex-sheet__hint">{copy.textHint}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalitySheet;
